

  
export default () => {
    const refresh = () => {
        window.location.reload();
    };

    return (
        <div style={{ height: '100vh' }}>
            <h4 style={{ margin: 'auto', textAlign: 'center', padding: '50px 0' }}>您的账户正在审核中，请稍后...</h4>
            <p style={{ textAlign: 'center' }}><a onClick={refresh}>刷新审核结果</a></p>
        </div>
    );
};